export const primaryAppColor = '#006699';
export const portalLoaderFontType = "'Lato', sans-serif";
